// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2641":"8238e736","2864":"8238e736","3505":"558a627f","5177":"8238e736","7016":"8238e736","9754":"8238e736","9864":"8238e736"}[chunkId] + ".chunk.css";
};